import { render, staticRenderFns } from "./SmartPOST.vue?vue&type=template&id=39d40c0c"
import script from "./SmartPOST.vue?vue&type=script&lang=ts"
export * from "./SmartPOST.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports